import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";

export class ZIDXThankYou implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxThankYouContainer";
    }
    render(){
        // console.log("thank you");

    }
}